export const environment = {
  configUrl: '/api/config/public',
  production: true,
  environmentName: 'development',
  hmr: false,
  auth0SessionWarningSeconds: 3600,
  auth0SessionTimeoutSeconds: 120,
  subdomain_redir: false,
  log_level: 'debug',
  google_storage_baseUrl: 'https://www.googleapis.com/upload/storage/v1/b/slapfive/o?uploadType=media',
  gcsServingUrl: 'https://media.slapfive.com',
};
